<template>
    <div style="background-color:#ffffff;border: 1px solid #eee;border-radius: 4px;">
        <div v-if="GET_VEDOMOST" class="mail-sidebar-content px-0  h-full">
            <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
                <div class="flex mb-4" v-if="GET_VEDOMOST.discipline">
                    <!-- заголовок, кнопка закрытия -->
                    <div class="lg:flex items-center">
                        <feather-icon @click="nazad" :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                        <h4 v-if="GET_VEDOMOST.discipline" class="mb-1 lg:mb-0">{{GET_VEDOMOST.discipline.name}}</h4>
                        <div v-if="GET_VEDOMOST.status_statements">
                            <vs-chip v-if="GET_VEDOMOST.status_statements.code=='NEW'" class="ml-2 text-sm"  color="primary">
                                {{GET_VEDOMOST.status_statements.name}}
                            </vs-chip>
                            <vs-chip v-else-if="GET_VEDOMOST.status_statements.code=='ONINSPECTION'" class="ml-2 text-sm"  color="warning">
                                {{GET_VEDOMOST.status_statements.name}}
                            </vs-chip>
                            <vs-chip v-else-if="GET_VEDOMOST.status_statements.code=='APPROVED'" class="ml-2 text-sm"  color="success">
                                {{GET_VEDOMOST.status_statements.name}}
                            </vs-chip>
                            <vs-chip v-else-if="GET_VEDOMOST.status_statements.code=='REJECTED'" class="ml-2 text-sm"  color="danger">
                                {{GET_VEDOMOST.status_statements.name}}
                            </vs-chip>
                        </div>
                        <vs-chip class="ml-2 text-sm"  color="warning">{{GET_VEDOMOST.study_year.start}}-{{GET_VEDOMOST.study_year.end}}</vs-chip>
                        <vs-chip class="ml-2 text-sm"  color="primary">{{GET_VEDOMOST.acad_period.name}}</vs-chip>
                        <vs-chip v-if="GET_VEDOMOST.closed.access" class="ml-2 text-sm"  color="success">
                            {{ $t('open3') }}
                        </vs-chip>
                        <vs-chip v-else class="ml-2 text-sm"  color="danger">
                            {{ $t('closed2') }}
                        </vs-chip>
<!--                        <vs-chip class="ml-2 text-sm"  color="primary">{{GET_VEDOMOST.control_form.AntiPlagiarismRequired}}</vs-chip>-->
                    </div>
                </div>
            </div>

            <div style="border: 1px solid #eee;width: 100%;" class="px-4 lg:px-0">
                <div class="vx-row">
                    <div class="vx-col w-full card_col">
                        <vx-card class="lg:py-4 journal_card_loader">
                            <vs-tabs class="info_tab" alignment="fixed" v-model="activeTab">
                                <vs-tab class="pt-8"  :label="$t('description')">
<!--                                    <component :is="'VuePerfectScrollbar'" class="scroll-area-info-content" :settings="settings" :key="$vs.rtl">-->
                                    <ItemViewInfo :vedomosti="GET_VEDOMOST"/>
<!--                                    </component>-->
                                </vs-tab>
                                <vs-tab class="pt-8"  :label="$t('vedomost')">
                                    <ItemViewJournal
                                        :status = "GET_VEDOMOST.status_statements"
                                        :AntiPlagiarismRequired="GET_VEDOMOST.control_form?GET_VEDOMOST.control_form.AntiPlagiarismRequired:false"
                                        :is_practice="GET_VEDOMOST.control_form?GET_VEDOMOST.discipline.is_practice:false"/>
                                </vs-tab>
                                <vs-tab class="pt-8" :label="$t('change_history')">
                                    <ItemViewJournalHistory/>
                                </vs-tab>
                            </vs-tabs>
                        </vx-card>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ItemViewInfo from './ItemViewInfo'
import ItemViewJournal from './ItemViewJournal'
import ItemViewJournalHistory from './ItemViewJournalHistory'
import vedomosti from '@/store/modules/vedomosti.js'
import { mapActions, mapGetters,mapState } from 'vuex'

export default {
    props: {
    },
    data () {
        return {
            showThread: false,
            activeTab: 0,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.50
            },
            isViewSidebarActive:true
        }
    },
    async created() {
        if(!this.$store.hasModule('vedomosti'))
            this.$store.registerModule('vedomosti', vedomosti)
        await this.openRequest()
    },
    methods: {
        ...mapActions({
            VEDOMOST: 'vedomosti/VEDOMOST',
        }),
        async openRequest(){
            var route = this.$route.query.uid
            await this.VEDOMOST(route)
        },
        nazad(){
            let query = {}
            if(this.$route.query){
                Object.keys(this.$route.query).forEach(key => {
                    query[key] = this.$route.query[key]
                })
            }
            if(query.uid){
                delete query.uid
            }
            delete query.study_plan
            this.$router.push({name: 'vedomosts',query: query})
        }
    },
    computed: {
        ...mapGetters({
            GET_VEDOMOST: 'vedomosti/GET_VEDOMOST',
        }),
        scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    components: {
        VuePerfectScrollbar,
        ItemViewInfo,
        ItemViewJournal,
        ItemViewJournalHistory
    }
}

</script>

<style lang="scss">
//.vx-card{
//    border-radius: 1px!important;
//}
.vx-card .vx-card__collapsible-content .vx-card__body{
    overflow: auto!important;

}
.scroll-area-info-content{
    height: calc(var(--vh, 1vh)*100 - 30rem);
}
.full-vs-sidebar .vs-sidebar{
    max-width: calc(100%);
}
.journal_card_loader{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
@media only screen and (max-width: 900px) {
    .card_col{
        padding: 0px!important;
        .vx-card__body{
            padding: 0.2rem!important;
        }
    }
}
@media only screen and (max-width: 760px) {
    .info_tab{
        button{
            font-size: 12px;
            padding: 6px;
        }
    }
}
</style>
